import { lazy } from 'react';
import Layout from '@/Layouts/Layout';
import NetworkErr from '@/pages/Errors/NetworkErr.page';
import NotFound from '@/pages/Errors/NotFound.page';
import { RouteObject } from 'react-router-dom';
import Partners from '@/pages/partners/Partners.page';
import Movie from '@/pages/projects/Movie';
import Games from '@/pages/projects/Games';
import AmanApp from '@/pages/projects/AmanApp.page';
import Series from '@/pages/projects/Series';
// import ComingSoon from '@/pages/comingsoon/ComingSoon';
const Index = lazy(() => import('@/pages/home.page'));
const About = lazy(() => import('@/pages/about/About.page'));
const Projects = lazy(() => import('@/pages/projects/Projects.page'));

const routes: RouteObject[] = [
    {
        path: '/',
        // element: <ComingSoon />,
        element: <Layout />,
        children: [
            { index: true, element: <Index /> },
            {
                path: 'about',
                element: <About />,
            },
            {
                path: 'partners',
                element: <Partners />,
            },
            {
                path: 'projects',
                element: <Projects />,
            },
            {
                path: 'projects/movie/:id',
                element: <Movie />,
            },
            {
                path: 'projects/series/:id',
                element: <Movie />,
            },
            {
                path: 'projects/games/:id',
                element: <Games />,
            },
            {
                path: 'projects/programs/:id',
                element: <AmanApp />,
            },
            {
                path: '*',
                element: <NotFound />,
            },
        ],
    },
];

export { routes };
